export default "__VITE_ASSET__BsfLRjzd__"